import { useState } from 'react';

export const ClientLogo = ({ name, logo, className, imgClassName, textClassName }) => {
    const [failed, setFailed] = useState(false);

    if (!logo || failed) {
        return (
            <span className={textClassName}>
                {name}
            </span>
        );
    }

    return (
        <img
            src={logo}
            alt={`${name} logo`}
            className={imgClassName}
            loading="lazy"
            onError={() => setFailed(true)}
        />
    );
};
